'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import clsx from 'clsx';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import { useSharedComponentsStyledContext } from "../SharedComponentsStyledContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const EventSkeletonRoot = styled(Skeleton, {
  name: 'MuiEventSkeleton',
  slot: 'Root'
})(({
  theme
}) => {
  // Typing the styles per variant makes adding a new `EventSkeletonVariant`
  // without a matching style block a compile error.
  const variantStyles = {
    'time-column': {
      position: 'absolute',
      left: 0,
      right: 12,
      top: 0,
      height: '100%',
      borderRadius: 0
    },
    'day-grid': {
      height: 18
    },
    agenda: {
      height: 28
    },
    'timeline-row': {
      height: `calc(${theme.typography.body2.lineHeight}em + ${theme.spacing(1.125)})`,
      width: '100%'
    }
  };
  return _extends({
    opacity: 0.5
  }, Object.fromEntries(Object.entries(variantStyles).map(([variant, style]) => [`&[data-variant="${variant}"]`, style])));
});
export function EventSkeleton(props) {
  const {
    classes
  } = useSharedComponentsStyledContext();
  return /*#__PURE__*/_jsx(EventSkeletonRoot, _extends({
    variant: "rounded",
    animation: "wave",
    "aria-hidden": true
  }, props, {
    className: clsx(classes.eventSkeleton, props.className)
  }));
}